// src/utils/departmentIcons.js
// ✅ Keep your existing Fc icons (so old saved icons still work)
// ✅ Add "operations" icons from FontAwesome (Fa)
// ✅ IMPORTANT: FaForklift does NOT exist in your react-icons install,
//    so we keep the KEY "FaForklift" but render a similar icon (FaTruckLoading)

import {
  FcBriefcase,
  FcBusiness,
  FcFactory,
  FcAssistant,
  FcDepartment,
  FcManager,
  FcServices,
  FcSettings,
  FcHome,
  FcGlobe,
  FcCalendar,
  FcClock,
  FcTodoList,
  FcInspection,
  FcReading,
  FcApproval,
  FcOrganization,
  FcSupport,
  FcPackage,
  FcShipped,
  FcInTransit,
} from "react-icons/fc";

import {
  FaTruck,
  FaTruckLoading, // ✅ use this as "forklift replacement"
  FaBoxes,
  FaBoxOpen,
  FaBarcode,
  FaClipboardCheck,
  FaUserShield,
  FaClock,
  FaUsers,
  FaHeadset,
  FaWarehouse,
  FaCogs,
  FaTools,
} from "react-icons/fa";

export const departmentIconMap = {
  // ✅ your existing (Fc)
  FcBriefcase,
  FcBusiness,
  FcFactory,
  FcAssistant,
  FcDepartment,
  FcManager,
  FcServices,
  FcSettings,
  FcHome,
  FcGlobe,
  FcCalendar,
  FcClock,
  FcTodoList,
  FcInspection,
  FcReading,
  FcApproval,
  FcOrganization,
  FcSupport,
  FcPackage,
  FcShipped,
  FcInTransit,

  // ✅ NEW operations icons (Fa)
  // Keep the key "FaForklift" for old saved values, but render FaTruckLoading
  FaForklift: FaTruckLoading,

  FaTruck,
  FaWarehouse,
  FaBoxes,
  FaBoxOpen,
  FaBarcode,
  FaClipboardCheck,
  FaUserShield,
  FaClock,
  FaUsers,
  FaHeadset,
  FaCogs,
  FaTools,
};

// ✅ this is what your icon grid uses
export const departmentIconList = Object.keys(departmentIconMap);
